import styled from 'styled-components'

import { ArrowRightIcon, Typography, useHapticFeedback } from '@blade/ui-kit'
import { useAppRoutes } from '@root/features/routing'
import { DomUtil } from '@root/shared'
import { useTranslation } from '@root/shared/localization'

import BG from './../assets/wallet-bg.inline.svg'

export const WalletsListEmpty: React.FC = () => {
  const { t } = useTranslation()
  const { navigateToNewWallet } = useAppRoutes()
  const haptics = useHapticFeedback()

  const handleOpen = () => {
    haptics.impactOccurred('light')
    navigateToNewWallet()
  }

  return (
    <Root>
      <Title>{t('wallet.no_wallets.banner.title')}</Title>
      <Subtitle>{t('wallet.no_wallets.banner.sub-title')}</Subtitle>
      <Button onClick={handleOpen}>
        {t('common.open')}
        <Icon />
      </Button>
    </Root>
  )
}

const Root = styled.div`
  background-image: ${DomUtil.cssUrl(BG)};
  background-color: var(--appearance-1);

  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 0;
  background-size: contain;

  border: 1px solid hsla(0, 0%, 100%, 0.1);
  height: 120px;

  border-radius: 12px;
  margin-inline: 12px;
  margin-top: 16px;

  padding-inline: 23px;
  padding-block: 18px;

  overflow: hidden;
`

const Title = styled.div`
  color: var(--text-12);

  font-size: 18px;
  font-weight: 700;
`

const Subtitle = styled(Typography).attrs({
  variant: 'body4-regular',
  component: 'div',
})`
  color: var(--text-10);
  margin-bottom: 12px;
`

const Button = styled.button`
  outline: none;
  border: none;
  background: var(--primary-9);

  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;

  gap: 11px;
  padding-inline-start: 12px;
  padding-inline-end: 2px;
  border-radius: 64px;
  height: 32px;
  font-size: var(--typography-body-4-bold-font-size);
  line-height: var(--typography-body-4-bold-line-height);
  font-weight: var(--typography-body-4-bold-font-weight);

  color: var(--text-12);
  text-align: center;
`

const Icon = styled(ArrowRightIcon)`
  color: var(--text-12);
  background: rgba(255, 255, 255, 0.18);

  border-radius: 50%;
  padding: 4px;
  width: 28px;
  height: 28px;
`
